import { Box, Button, Collapse, Grid, Typography } from "@mui/material"
import useAuth from "../../../../../../context/auth"
import moment from "moment"
import { Format } from "../../../../../../utils"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"

export const History = () => {
    const { user } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }, [])
    

    return (
        <Grid>
            <Typography fontWeight={600} fontSize={"2rem"} p={0}>Lista completa</Typography>

            <Typography fontWeight={600} fontSize={"1.4rem"} p={0} mt={"1.5rem"} mb={"1rem"}>Diárias</Typography>

            <Collapse in={(user?.actualContract?.parcels ?? []).length > 0}>
                <Grid
                    sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: ".3rem"
                    }}
                >
                    <Box
                        key={"parcel-header"}
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "nowrap",
                            justifyContent: "space-between",
                            alignItems: "center",
                            boxSizing: "border-box",
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            borderRadius: "10px",
                            minHeight: "3.7rem",
                            padding: ".3rem 1rem",
                        }}
                    >
                        <Typography fontSize={"1.6rem"} fontWeight={600}>Diárias</Typography>
                        <Typography fontSize={"1.2rem"} fontWeight={400} sx={{ opacity: 0.5, ml: "-3rem" }} textAlign={"center"}>Vencimento</Typography>
                        <Typography fontSize={"1.6rem"} fontWeight={700} color="secondary">Valor</Typography>
                    </Box>
                    {user?.actualContract?.parcels?.map((parcel) => {
                        return (
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    boxSizing: "border-box",
                                    backgroundColor: parcel.status === 10 ? "rgba(0, 0, 0, 0.25)" : parcel.status === 5 ? "rgb(248 197 197 / 33%)" : "rgba(255, 255, 255, 1)",
                                    borderRadius: "10px",
                                    minHeight: "3.7rem",
                                    padding: ".3rem 1rem",
                                    opacity: parcel.status === 10 ? 0.5 : 1
                                }}
                            >
                                <Typography fontSize={"1.6rem"} fontWeight={600} sx={{ opacity: parcel.status === 10 ? 0.5 : 1 }} color={parcel.status === 5 ? "red" : "inherit"}>{parcel.index} de 24</Typography>
                                <Typography fontSize={"1.2rem"} fontWeight={400} sx={{ opacity: 0.5 }} textAlign={"center"}>{parcel.status === 10 ? "Pago" : "Venc."}: {moment(parcel.dueAt).format("DD/MM/YY")}<br />{moment(parcel.dueAt).format("[(]dddd[)]")}</Typography>
                                <Typography fontSize={"1.6rem"} fontWeight={700} sx={{ opacity: parcel.status === 10 ? 0.5 : 1 }} color={parcel.status === 10 ? "black" : parcel.status === 5 ? "red" : "secondary"}>{Format.currency(parcel.total)}</Typography>

                            </Box>
                        )
                    })}
                </Grid>
            </Collapse>

            <Grid
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <Button
                    sx={{
                        height: "4rem",
                        mt: "2rem"
                    }}
                    variant="outlined"
                    onClick={() => navigate(-1)}
                >Voltar</Button>
            </Grid>

        </Grid>
    )
}